/**
 * ```ts
 * declare const a: null | number;
 *
 * const example = (() => {
 *     if (isNonNullable(a)) {
 *       const c: number = a;
 *     } else {
 *       const b: null = a;
 *     }
 *   }
 * )
 * ```
 */
export function isNonNullable<T>(value: T): value is NonNullable<T> {
  return value !== null && value !== undefined;
}
